module.exports = __webpack_public_path__ + "img/dany_TF_wordcloud.0cc4ccac.png";